// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --p: 0;
  --b: 2px;
  --c: #ff4949;
  --w: 16px;
}

.nav-link.cta-btn:hover,
.nav-link.cta-btn.active {
  background: var(--darkSlate);
  color: var(--white);
}

.modal-backdrop {
  display: none;
}

header {
  background: var(--theme-dark);
  border-bottom: 1px solid var(--sidebarTooltip);
  position: relative;
  padding: 0 1rem;
  z-index: 11;
  padding-right: 14px;
  position: fixed;
  top: 0;
  width: 100%;
  min-height: 76px;
}
header .brand-logo svg {
  width: 158px;
}
@media screen and (max-width: 1199.98px) {
  header .brand-logo svg {
    width: 50px;
    height: 50px;
  }
}
header .header-middile-btn {
  gap: 0.5rem;
}
header .header-middile-btn .btn-primary {
  background: var(--socialLinksBg);
  display: flex;
  align-items: center;
  justify-content: center;
}
header .header-middile-btn .btn-primary:hover {
  background: var(--sidebarBtnGradient);
}
header .header-middile-btn .btn-primary.currencies-btn {
  background: var(--darkGray);
  border: none;
}
header .header-middile-btn .btn-primary.currencies-btn:hover {
  background: var(--socialLinksBg) !important;
  color: var(--white);
}
@media screen and (max-width: 575.98px) {
  header .header-middile-btn .btn-primary.currencies-btn {
    padding: 0.25rem 0.5rem;
  }
}
header .header-social-links a {
  height: 2.75rem;
  width: 2.75rem;
  border-radius: 0.625rem;
  background: var(--sidebarTooltip);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
header .header-social-links a:not(:last-child) {
  margin-right: 0.5rem;
}
header .header-social-links a:hover {
  background: var(--headerBtnHover);
}
header .header-social-links a:hover svg {
  fill: var(--headingLink);
}
@media only screen and (min-width: 768px) and (max-width: 1480.98px) {
  header.sidebar-close .brand-logo {
    margin-left: 0;
  }
}
header .auth-btn.btn-primary {
  min-width: 120px;
  border: 1px solid var(--headingLink);
  background: transparent;
  color: var(--headingLink);
}
header .auth-btn.btn-primary:hover {
  color: var(--headingLink);
  background: transparent !important;
  border-color: var(--headingLink);
}
@media screen and (max-width: 991.98px) {
  header .auth-btn.btn-primary {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 767.98px) {
  header .auth-btn.btn-primary {
    min-width: 70px;
    font-size: 0.75rem;
  }
}
header .auth-btn.btn-secondary {
  min-width: 120px;
}
@media screen and (max-width: 991.98px) {
  header .auth-btn.btn-secondary {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 767.98px) {
  header .auth-btn.btn-secondary {
    min-width: 70px;
    font-size: 0.75rem;
  }
}
header .search-btn {
  width: 45px;
  align-items: center;
  justify-content: center;
  padding: 0;
}
header .search-btn svg {
  height: 1.2rem;
  width: 1.2rem;
}
header .search-btn.btn-primary {
  background: var(--sidebarTooltip);
  border-color: var(--sidebarTooltip);
  position: relative;
}
header .search-btn .theme-modal .modal-dialog {
  position: relative;
}
header .reward-menu-wrap .reward-menu {
  min-width: 415px;
  left: -60% !important;
  padding-top: 1.2rem;
  max-height: calc(100dvh - 38rem);
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 200px;
}
header .reward-menu-wrap .reward-menu .dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  padding: 0.313rem 0;
}
header .reward-menu-wrap .reward-menu .dropdown-item:hover {
  background: transparent;
}
header .reward-menu-wrap .reward-menu .dropdown-item:hover img {
  filter: none;
}
header .reward-menu-wrap .reward-menu .dropdown-item .reward-menu-content h4 {
  font-size: 0.875rem;
  text-transform: uppercase;
  padding-bottom: 0.1rem;
}
header .reward-menu-wrap .reward-menu .dropdown-item .reward-menu-content p {
  font-size: 0.75rem;
  font-weight: 300;
  color: var(--liveGreen);
}
header .reward-menu-wrap .reward-menu .dropdown-item .btn {
  height: auto;
  padding: 0.2rem 1rem;
  font-size: 0.75rem;
}
header .reward-menu-wrap .reward-menu .dropdown-item .btn svg {
  width: 1rem;
  height: 1rem;
  margin-right: 0.313rem;
}
header .reward-menu-wrap .reward-menu .dropdown-item .btn.btn-green {
  background: var(--liveGreen);
}
header .reward-menu-wrap .reward-menu .dropdown-item .btn.btn-green:hover {
  background: transparent;
  border-color: var(--primaryBtnBorder);
}
header .reward-menu-wrap .reward-menu .dropdown-item .reward-menu-icon {
  margin-right: 0.313rem;
}
header .reward-menu-wrap .reward-menu .dropdown-item .reward-menu-icon svg {
  height: 3rem;
  width: 3rem;
  margin: 0;
}
header .reward-menu-wrap .reward-menu .dropdown-btn-wrap .btn-primary {
  background: var(--socialLinksBg);
}
header .reward-menu-wrap .reward-menu .dropdown-btn-wrap .btn-primary:hover {
  background: var(--secondaryRadialBtn);
  border-color: var(--secondaryBtnBorder);
}
header .provider-list .casino-search {
  background: transparent;
}
header .provider-list .casino-search .search-icon {
  top: 0.9rem;
}
header .provider-list .casino-search input {
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.19) !important;
}
header .header-toggle-icon,
header .header-user-menu {
  margin-left: 1rem;
}
header .reward-btn .btn-primary {
  padding: 0.625rem 0.5rem;
  background: var(--primaryGradient);
  border: 1px solid var(--sidebarTooltip);
}
header .reward-btn .btn-primary .dropdown-icon {
  width: 24px;
  height: 24px;
  border-radius: 0.5rem;
  background-color: var(--sidebarTooltip);
  line-height: 1.6;
}
header .reward-btn .btn-primary:hover .dropdown-icon {
  background-color: var(--selectBg);
}
header .top-header-right {
  display: flex;
}
header .top-header-right .btn-primary {
  position: relative;
}
header .top-header-right .btn-primary svg {
  position: absolute;
  transform: translate(-50%, -50%);
}
header .top-header-right .btn-primary svg:nth-child(2) {
  opacity: 0;
}
header .top-header-right .btn-primary:hover {
  background: var(--headerBtnHover) !important;
}
header .top-header-right .btn-primary:hover svg {
  fill: var(--headingLink);
}

.search-dilog {
  max-width: 1408px;
}
.search-dilog .search-modal {
  background-color: var(--inputbg) !important;
}
.search-dilog .search-modal .search-modal-wrap {
  padding: 2rem;
}
.search-dilog .search-modal .search-modal-wrap .nav-link {
  background: var(--authTabBtn);
  min-width: 100%;
  width: 100%;
  margin: 0;
  justify-content: flex-start;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 0;
  padding: 0.6rem 1rem;
  min-height: 2.5rem;
}
.search-dilog .search-modal .search-modal-wrap .nav-link.active, .search-dilog .search-modal .search-modal-wrap .nav-link:hover {
  background: var(--profileCard);
}
.search-dilog .search-modal .search-modal-wrap .nav-link.active img, .search-dilog .search-modal .search-modal-wrap .nav-link:hover img {
  filter: brightness(10);
}
.search-dilog .search-modal .search-modal-wrap .nav-link img {
  margin-right: 0.8rem;
  width: 1rem;
}
@media screen and (max-width: 767.98px) {
  .search-dilog .search-modal .search-modal-wrap .search-modal-right-section {
    padding: 0;
  }
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-modal-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-modal-heading h4 {
  color: var(--white);
  margin: 0;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 1.375rem;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .casino-search {
  flex: 1 1;
  margin-right: 0;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .casino-search input {
  height: 40px;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary {
  font-size: 0.875rem;
  min-height: 2.75rem;
  background: var(--socialLinksBg);
  border-color: var(--socialLinksBg);
  cursor: pointer;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary span {
  color: var(--authTabActiveBorder);
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary:hover, .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary:active, .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary.show, .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary:visited {
  background: var(--darkGray) !important;
  border-color: var(--darkGray);
}
@media screen and (max-width: 767.98px) {
  .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right {
    justify-content: space-between;
  }
  .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn {
    width: 100%;
  }
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .global-casino-section {
  padding: 0 0.625rem;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .global-casino-section .theme-card-wrap {
  margin: 0.5rem 0;
  width: 100%;
  min-width: 100%;
}
@media screen and (max-width: 767.98px) {
  .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .load-more-wrap .btn {
    justify-content: center;
  }
}
@media screen and (min-width: 1200px) {
  .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .global-casino-section .col-lg-2 {
    width: 14.285%;
  }
}
.search-dilog .search-modal .search-modal-wrap .profile-tabs {
  position: sticky;
  top: 1rem;
  background: var(--authTabBtn);
  border-radius: 0.625rem;
  padding: 0;
  overflow: hidden;
  max-width: 190px;
  margin-right: 2rem;
}

@media screen and (max-width: 1199.98px) {
  .auth-modal-wrap {
    min-width: 80%;
  }
}

.casino-header {
  padding: 20px 15px 20px 75px;
}

@media screen and (max-width: 767.98px) {
  .currency-wrapper .btn-wallet {
    padding: 4px 11px;
  }
}
header .menuBtn {
  display: none;
  z-index: 1;
}

header .menuBtn.toggleBtn {
  transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
}

.chat-sidebar {
  position: fixed;
  right: 0;
  top: 4.75rem;
  background: var(--theme-dark);
  height: calc(100dvh - 50px);
  width: 248px;
}
.chat-sidebar .chat-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.chat-sidebar.chat-collapse {
  width: 340px;
}
@media screen and (max-width: 767.98px) {
  .chat-sidebar.chat-collapse {
    width: 100%;
  }
}
.chat-sidebar.chat-collapse .chat-collapse-icon {
  transform: rotate(180deg);
}
.chat-sidebar.chat-collapse .chat-collapse-icon svg {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}
.chat-sidebar.chat-collapse .btn-secondary {
  min-width: 110px;
}
@media screen and (max-width: 767.98px) {
  .chat-sidebar {
    width: 100%;
  }
}
.chat-sidebar .chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--theme-border);
  padding: 16px;
}
.chat-sidebar .chat-header .chat-btn {
  background: var(--headerBtnHover) !important;
  display: flex;
  align-items: center;
  width: 4.75rem !important;
  justify-content: center;
}
.chat-sidebar .chat-header .language-btn a {
  color: var(--white);
  font-weight: 600;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
}
.chat-sidebar .chat-header .language-btn a i {
  font-size: 1rem;
}
.chat-sidebar .chat-header .btn-primary {
  background: transparent;
  border: none;
  width: 100%;
  font-size: 0.74rem;
  margin: 0rem 0.213rem;
  padding: 0rem 0.45rem;
  box-shadow: none;
  color: var(--chatText);
  min-height: 2.25rem;
  font-weight: 500;
}
.chat-sidebar .chat-header .btn-primary svg {
  margin-right: 0.313rem;
}
.chat-sidebar .chat-header .btn-primary.active, .chat-sidebar .chat-header .btn-primary:hover {
  border-color: transparent;
  background: transparent;
  color: var(--white);
}
.chat-sidebar .chat-header .btn-secondary {
  height: 2.375rem;
  width: 100%;
  font-size: 0.74rem;
  margin: 0 0.313rem;
  padding: 0.25rem 0.625rem;
  box-shadow: none;
}
@media screen and (max-width: 767.98px) {
  .chat-sidebar .chat-header .btn-secondary {
    min-width: 140px;
  }
}
.chat-sidebar .chat-header .btn-secondary.active, .chat-sidebar .chat-header .btn-secondary:hover {
  border-color: var(--primaryBtnBorder);
  background: transparent;
  color: var(--white);
}
.chat-sidebar .chat-header > a {
  width: 100%;
  color: var(--white);
  text-align: center;
  font-size: 0.74rem;
  background: var(--authTabBtn);
  min-height: 2.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.625rem;
  margin: 0 0.313rem;
  border: 1px solid var(--authTabBtn);
}
.chat-sidebar .chat-header > a.active, .chat-sidebar .chat-header > a:hover {
  background: var(--inputbg);
  border-color: var(--secondaryBtnBorder);
  color: var(--secondaryBtnBorder);
}
.chat-sidebar .chat-header .chat-close {
  background: transparent;
  padding: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  border: none;
  position: relative;
  color: var(--chatIcon);
}
.chat-sidebar .chat-header .chat-close.active, .chat-sidebar .chat-header .chat-close:hover {
  background: transparent;
  border-color: transparent;
  color: var(--headingLink);
}
.chat-sidebar .chat-header .chat-collapse-icon {
  background: transparent;
  padding: 0;
  margin: 0 0.2rem;
  width: 5rem;
  align-items: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  position: relative;
}
.chat-sidebar .chat-header .chat-collapse-icon.active, .chat-sidebar .chat-header .chat-collapse-icon:hover {
  background: transparent;
  border-color: transparent;
}
.chat-sidebar .chat-header .chat-collapse-icon.active svg path:nth-child(1), .chat-sidebar .chat-header .chat-collapse-icon:hover svg path:nth-child(1) {
  stroke: var(--headingLink);
}
.chat-sidebar .chat-header .chat-collapse-icon.active svg path:nth-child(2), .chat-sidebar .chat-header .chat-collapse-icon:hover svg path:nth-child(2) {
  fill: var(--headingLink);
}
@media screen and (max-width: 991.98px) {
  .chat-sidebar .chat-header .chat-collapse-icon {
    display: none;
  }
}
.chat-sidebar .chat-header .dropdown-toggle::after {
  display: inline-block;
}
.chat-sidebar .chat-header .dropdown-menu {
  min-width: 100%;
  padding: 0.25rem;
}
.chat-sidebar .chat-header .dropdown-menu a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.75rem;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
}
.chat-sidebar .chat-header .dropdown-menu a img {
  width: 18px;
  object-fit: cover;
}
.chat-sidebar .chat-announcement-card {
  background: var(--headingLink);
  border-radius: 0.313rem;
  margin: 0.313rem 0;
  padding: 0.625rem;
  position: relative;
}
.chat-sidebar .chat-announcement-card p {
  color: var(--white);
  font-size: 0.75rem;
  margin: 0;
  padding-right: 0.4rem;
  line-height: 1.3;
  word-break: break-all;
}
.chat-sidebar .chat-announcement-card a {
  color: var(--white);
  font-size: 0.625rem;
}
.chat-sidebar .chat-content-scroll {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0px;
  overflow-wrap: break-word;
  overflow: hidden auto;
  margin-bottom: 30px;
  border-bottom: 2px solid var(--inputBorder);
}
@media screen and (max-width: 1199.98px) {
  .chat-sidebar .chat-content-scroll {
    height: calc(100vh - 315px);
  }
}
@media screen and (max-width: 767.98px) {
  .chat-sidebar .chat-content-scroll {
    height: calc(100vh - 315px);
  }
}
.chat-sidebar .chat-content-scroll .empty-chat {
  width: 100%;
  padding: 5px;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap {
  padding: 1rem 1rem 0.5rem 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-bubble:nth-child(1) {
  margin-top: auto;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .new_message {
  color: #00a4fa;
  text-align: center;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .new_message::before {
  background-color: #00a4fa;
  content: "";
  display: inline-block;
  height: 1px;
  position: relative;
  vertical-align: middle;
  width: 100%;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .new_message::before {
  right: 0.5em;
  margin-left: -50%;
}
@media screen and (max-width: 767.98px) {
  .chat-sidebar .chat-content-scroll .chat-content-wrap {
    width: 100%;
    height: calc(100vh - 260px);
  }
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card {
  margin: 0.25rem 0;
  border-radius: 0.5rem;
  background: var(--chatCardBg);
  padding: 0.75rem;
  color: var(--white);
  word-break: break-word;
  position: relative;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card h4 {
  font-weight: 600;
  padding-right: 0.313rem;
  cursor: pointer;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card p span {
  font-weight: 400;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card p .tagged-name {
  color: var(--white);
  font-weight: 400;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card p .chat-msg {
  color: var(--listitemtext);
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .user-icon {
  width: 1rem;
  margin-right: 0.313rem;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card:first-child {
  margin-top: auto;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .chat-badge-lising {
  margin: 0 0.1rem;
  display: flex;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .chat-badge-lising svg {
  margin: 0 0.1rem;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .chat-avtar img {
  object-fit: cover;
  border-radius: 12px;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .user-clr-one {
  margin-bottom: 0;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .user-clr-one img {
  object-fit: cover;
  border-radius: 12px;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .user-clr-one .chat-user-label {
  vertical-align: middle;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--white);
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .user-clr-one .gif_img {
  pointer-events: none;
  cursor: default;
  height: 75px;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-time {
  font-size: 0.625rem;
  font-weight: 300;
  color: var(--chatText);
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-text {
  color: var(--listitemtext);
  word-break: break-all;
  font-size: 0.875rem;
  line-height: 26px;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .report-user-wrap {
  background: var(--userreportBg);
  padding: 0.2rem;
  min-width: 32px;
  min-height: 30px;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0.313rem;
  top: 0;
  display: none;
  cursor: pointer;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card:hover .report-user-wrap {
  display: flex;
}
.chat-sidebar .chat-content-scroll::-webkit-scrollbar {
  width: 0;
}
.chat-sidebar .chat-bottom-section {
  padding: 1rem 1rem 1.5rem 1rem;
  position: relative;
  top: -1.875rem;
}
@media screen and (max-width: 1199.98px) {
  .chat-sidebar .chat-bottom-section {
    padding: 1rem 1rem 4rem 1rem;
  }
}
.chat-sidebar .chat-bottom-section .chat-typing {
  position: relative;
}
.chat-sidebar .chat-bottom-section .chat-typing textarea {
  background-color: var(--inputbg) !important;
  font-size: 0.875rem !important;
  border: 2px solid var(--inputBorder) !important;
  padding-right: 4.375rem !important;
  border-radius: 0.5rem;
  margin-bottom: 0.625rem;
  color: var(--authSocailTextColor);
  font-family: "Rubik", sans-serif !important;
}
.chat-sidebar .chat-bottom-section .chat-typing textarea:focus {
  outline: none;
  color: var(--white);
}
.chat-sidebar .chat-bottom-section .chat-typing textarea:focus::placeholder {
  color: var(--white) !important;
}
.chat-sidebar .chat-bottom-section .chat-typing div .giphy-carousel {
  width: 285px;
  position: absolute;
  bottom: 79px;
  right: 0;
}
.chat-sidebar .chat-bottom-section .chat-typing div .giphy-carousel .giphy-gif {
  width: 100px !important;
  height: 100px !important;
}
.chat-sidebar .chat-bottom-section .chat-typing div .giphy-carousel .giphy-attribution {
  display: none !important;
}
.chat-sidebar .chat-bottom-section .chat-typing div button {
  border: 1px solid transparent;
  background-color: transparent !important;
}
.chat-sidebar .chat-bottom-section .chat-typing .chat-input-cta {
  position: absolute;
  z-index: 1;
  right: 0.625rem;
  bottom: 0.5rem;
}
.chat-sidebar .chat-bottom-section .chat-typing .chat-input-cta svg {
  cursor: pointer;
  margin: 0 0.2rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap {
  margin-top: 0.625rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .btn {
  min-height: 1.688rem;
  padding: 0 0.5rem;
  font-size: 0.74rem;
  border-radius: 0.375rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap img {
  margin-right: 0.313rem;
  width: 0.875rem;
  height: 0.875rem;
  border-radius: 1rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap a {
  color: var(--listitemtext);
  font-weight: 400;
  font-size: 0.75rem;
  display: flex;
  gap: 5px;
  padding: 0.45rem;
  align-items: center;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap a i {
  font-size: 1rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .chat-rules {
  background-color: var(--socialLinksBg);
  padding: 6px;
  border-radius: 4px;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .chat-rules:focus {
  background: var(--headerBtnHover);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .chat-rules:focus svg path {
  stroke: var(--headingLink);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap ul {
  background-color: var(--sidebarTooltip);
  padding: 12px;
  min-width: 9rem;
  box-shadow: var(--dropdownShadow);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap ul li {
  border-radius: 4px;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap ul li:hover {
  background: var(--headerBtnHover);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap ul li:hover a {
  color: var(--listitemtext);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap ul li:hover a:hover {
  background: transparent;
  color: var(--white);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap {
  border: 2px solid var(--c);
  border-radius: 50%;
  height: 14px;
  width: 14px;
  margin-right: 6px;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .pie {
  width: var(--w);
  aspect-ratio: 1;
  position: relative;
  display: inline-grid;
  place-content: center;
  font-size: 25px;
  font-weight: bold;
  font-family: sans-serif;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .pie:before,
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .pie:after {
  content: "";
  position: absolute;
  border-radius: 50%;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .pie:before {
  inset: 2px;
  background: radial-gradient(farthest-side, var(--c) 98%, rgba(0, 0, 0, 0)) top/var(--b) var(--b) no-repeat, conic-gradient(var(--c) calc(var(--p) * 1%), rgba(0, 0, 0, 0) 0);
  mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(99% - var(--b)), #000 calc(100% - var(--b)));
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .pie:after {
  inset: calc(50% - var(--b) / 2);
  background: var(--c);
  transform: rotate(calc(var(--p) * 3.6deg)) translateY(calc(50% - var(--w) / 2));
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .animate {
  animation: p 1s 0.5s both;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .no-round:before {
  background-size: 0 0, auto;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .no-round:after {
  content: none;
}
@keyframes p {
  from {
    --p: 0;
  }
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .text-limit {
  width: 25px;
  font-size: 0.875rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .btn-primary {
  font-weight: 400 !important;
  font-size: 0.875rem !important;
  min-height: 2rem;
  max-width: 100px;
  min-width: 100px;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .btn-primary:hover, .chat-sidebar .chat-bottom-section .chat-details-wrap .btn-primary:focus, .chat-sidebar .chat-bottom-section .chat-details-wrap .btn-primary:active {
  background: var(--headerBtnHover) !important;
  border: none;
  color: var(--white);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .btn-secondary {
  font-weight: 500 !important;
  font-size: 1rem !important;
  max-width: 56px;
  min-width: 56px;
  min-height: 32px;
}
.chat-sidebar .chat-bottom-section .gif-input {
  height: 2rem !important;
  margin-bottom: 0.25rem !important;
  width: 80%;
  margin: 0 auto;
}

.user-profile-modal .modal-body {
  padding: 0.625rem !important;
}
.user-profile-modal .btn-close {
  background-color: var(--headerBtnHover) !important;
  border: 2px solid var(--theme-dark) !important;
  opacity: 1 !important;
}

.chat-modal {
  color: var(--white);
}
.chat-modal .btn-close {
  position: absolute;
  height: 1rem;
  width: 1rem;
  right: 0.313rem;
  top: 0.313rem;
  border-radius: 100%;
  background: var(--chatModalClose);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 767.98px) {
  .chat-modal .btn-close {
    right: 0.625rem;
    top: 0.625rem;
  }
}
.chat-modal .btn-close:hover {
  opacity: 1;
}
.chat-modal .btn-close svg {
  width: 0.625rem;
  height: 0.625rem;
}
.chat-modal .modal-dialog {
  max-width: 436px;
}
@media screen and (max-width: 767.98px) {
  .chat-modal .modal-dialog {
    max-width: 100%;
    padding: 0.625rem;
    margin: 0;
  }
}
.chat-modal .chat-modal-header-wrap {
  background: var(--chatCardBg);
  border-radius: 0.625rem;
  margin-bottom: 0.5rem;
  padding: 1rem;
}
.chat-modal .chat-modal-header-wrap h4 {
  text-transform: capitalize;
  margin: 0;
  padding-right: 1rem;
  font-size: 1.125rem;
  font-weight: 600;
}
.chat-modal .chat-modal-header-wrap .tip-btn {
  height: 1.5rem;
  min-height: 1.5rem;
  background: var(--tipBtnBg);
  border: 1px solid var(--authTabActiveBorder);
  border-radius: 0.313rem;
  color: var(--white);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.5rem 0 0.313rem;
  margin-right: 0.75rem;
}
.chat-modal .chat-modal-header-wrap .tip-btn img {
  width: 0.938rem;
  height: 0.938rem;
}
.chat-modal .chat-modal-header-wrap .edit-btn {
  min-height: unset;
  height: 1.5rem;
  width: 1.5rem;
  border: 1px solid var(--headerBtnHover);
  border-radius: 0.313rem;
  color: var(--authSocailTextColor);
  font-size: 0.875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0 0.5rem 0 auto;
}
.chat-modal .chat-modal-header-wrap .edit-btn i {
  font-size: 13px;
}
.chat-modal .chat-modal-header-wrap .chat-modal-header-right {
  flex: 1 1;
}
.chat-modal .chat-modal-header-wrap .chat-modal-header-right .progress {
  height: 6px;
}
.chat-modal .chat-modal-content {
  background: var(--chatCardBg);
  border-radius: 0.625rem;
  margin-top: 0.5rem;
  padding: 0.625rem;
}
.chat-modal .chat-modal-content .chat-bets h4 {
  color: var(--authSocailTextColor);
  font-size: 0.875rem;
  font-weight: 500;
}
.chat-modal .chat-modal-content .chat-bets p {
  color: var(--white);
  font-size: 0.875rem;
  padding-left: 0.313rem;
  font-weight: 500;
}
.chat-modal .progrees-content p {
  font-size: 0.875rem;
  color: var(--authSocailTextColor);
  font-weight: 500;
}
.chat-modal .progrees-content p span {
  color: var(--liveGreen);
  padding: 0 0.2rem;
  font-weight: 600;
}
.chat-modal .favourites-game-wrap {
  margin-right: 1rem;
}
.chat-modal .favourites-game-wrap .favourites-game-img {
  height: 78px;
  width: 78px;
  border-radius: 0.313rem;
  overflow: hidden;
  margin-right: 1rem;
}
.chat-modal .favourites-game-wrap .favourites-game-img img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.chat-modal .favourites-game-wrap .favourites-game-right p {
  font-size: 0.75rem;
  color: var(--authTabBtnText);
  font-weight: 600;
}
.chat-modal .favourites-game-wrap .favourites-game-right h4 {
  color: var(--white);
  font-size: 1rem;
  max-width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 700;
}
.chat-modal .chat-modal-profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chat-modal .chat-modal-profile-img {
  width: 5rem;
  min-width: 5rem;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.chat-modal .chat-modal-profile-img img {
  width: 100%;
  height: 100%;
  border-radius: 3.313rem;
  object-fit: cover;
  object-position: center;
}
.chat-modal .chat-modal-header-left {
  width: 4.375rem;
  padding: 0.25rem;
}
.chat-modal .chat-modal-header-left img {
  width: 100%;
  max-width: 62px;
  height: auto;
}
.chat-modal .modal-body {
  padding: 0.625rem;
  background: var(--theme-dark);
  border-radius: 1rem;
  border: 1px;
}

.account-btn-mid-content {
  font-weight: 600;
}
@media screen and (max-width: 767.98px) {
  .account-btn-mid-content p {
    font-size: 0.74rem;
  }
}

@media screen and (max-width: 767.98px) {
  .btn.balance-btn {
    font-size: 0.74rem;
  }
}
.btn.balance-btn:hover {
  background: var(--darkGray);
  cursor: default;
}
@media screen and (max-width: 767.98px) {
  .btn {
    padding: 0.25rem 0.625rem;
  }
}

.chat-modal-wrap .modal-dialog {
  position: relative;
  border-radius: 0.625rem;
  min-width: 620px;
}
.chat-modal-wrap .btn-close {
  filter: invert(10);
  opacity: 1;
  width: 0.625rem;
  background-size: 0.625rem;
  right: 0.313rem;
  top: 0.313rem;
  position: absolute;
  z-index: 1;
  box-shadow: none;
}

.upload-modal .modal-dialog {
  max-width: 468px !important;
}
.upload-modal .modal-dialog .btn-close {
  border-radius: 100%;
  background: var(--chatModalClose);
  opacity: 1;
  top: 1.5rem;
  right: 1.5rem;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box {
  position: relative;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box svg {
  width: 45px;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box .drop-title {
  margin-bottom: 0;
  font-weight: 500;
  font-size: 0.875rem;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box .drop-title span {
  color: var(--headingLink);
  text-decoration: underline;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box .drop-title span:hover {
  text-decoration: none;
  cursor: pointer;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box .drop-title ::-webkit-file-upload-button {
  cursor: pointer;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box .drop-limit {
  margin-bottom: 0;
  font-weight: 400;
  font-size: 0.875rem;
  color: var(--authSocailTextColor);
}
.upload-modal .modal-dialog .profile-pic-wrapper input[type=file] {
  position: absolute;
  top: -2px;
  height: 20px;
  right: 0;
  width: 50px;
  cursor: pointer;
  opacity: 0;
}
.upload-modal .modal-footer .btn-primary {
  border: 1px solid var(--headingLink);
}

.tip-modal .modal-dialog {
  max-width: 400px;
  min-width: 400px;
}
@media screen and (max-width: 767.98px) {
  .tip-modal .modal-dialog {
    max-width: 100%;
    min-width: 100%;
  }
}
.tip-modal .modal-dialog .modal-content {
  overflow: hidden;
}
.tip-modal .modal-dialog .modal-content h3 {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
}
.tip-modal .modal-dialog .modal-content .form-label,
.tip-modal .modal-dialog .modal-content .form-check label {
  font-size: 0.75rem;
}
.tip-modal .modal-dialog .modal-content .modal-footer {
  background: var(--weekBg);
  padding: 1.5rem;
  justify-content: flex-start;
}

#profile-pic-modal .modal-footer {
  background: transparent;
}

.cashier-modal .modal-dialog {
  min-width: 805px;
}
@media screen and (max-width: 1024.98px) {
  .cashier-modal .modal-dialog {
    min-width: 100%;
    margin: 0;
    padding: 0.625rem;
  }
}
.cashier-modal .modal-dialog .modal-body {
  padding: 2rem;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-body {
    padding: 0.625rem 1rem;
  }
}
.cashier-modal .modal-dialog .modal-body .nav-link {
  color: var(--authSocailTextColor);
  opacity: 0.8;
}
.cashier-modal .modal-dialog .modal-body .nav-tabs .nav-item .nav-link:hover,
.cashier-modal .modal-dialog .modal-body .nav-tabs .nav-item .nav-link.active,
.cashier-modal .modal-dialog .modal-body .nav-pills .nav-item .nav-link:hover,
.cashier-modal .modal-dialog .modal-body .nav-pills .nav-item .nav-link.active {
  color: var(--white);
  border-color: var(--nft-badge);
}
.cashier-modal .modal-dialog .modal-body .deposit-step-one .deposit-card {
  background: var(--weekBg);
  padding: 2rem;
  text-align: center;
  border-radius: 0.313rem;
  cursor: pointer;
  height: 100%;
}
.cashier-modal .modal-dialog .modal-body .deposit-step-one .deposit-card .deposit-card-icon {
  height: 30px;
  width: 30px;
  border-radius: 100%;
  margin: 0 auto 0.625rem;
}
.cashier-modal .modal-dialog .modal-body .deposit-step-one .deposit-card .deposit-card-icon img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.cashier-modal .modal-dialog .modal-body .deposit-step-one .deposit-card h4 {
  color: var(--white);
  margin: 0;
  font-size: 1rem;
}
.cashier-modal .modal-dialog .modal-body .deposit-step-one .deposit-card p {
  color: var(--authSocailTextColor);
  text-transform: capitalize;
  margin: 0;
  font-size: 0.875rem;
}
.cashier-modal .modal-dialog .cashier-heading {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .cashier-heading {
    flex-direction: column;
    align-items: flex-start;
  }
}
.cashier-modal .modal-dialog .cashier-heading h3 {
  display: flex;
  align-items: center;
  font-size: 1.375rem;
  color: var(--white);
  font-weight: 700;
}
.cashier-modal .modal-dialog .cashier-heading a {
  color: var(--headingLink);
  font-size: 0.875rem;
  padding-left: 0.625rem;
  font-weight: 700;
}
.cashier-modal .modal-dialog .cashier-heading .currency-icon {
  height: 30px;
  width: 30px;
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.625rem;
}
.cashier-modal .modal-dialog .cashier-heading .currency-icon img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.cashier-modal .modal-dialog .cashier-heading .left-arrow {
  padding: 0;
}
.cashier-modal .modal-dialog .cashier-heading .left-arrow svg {
  filter: brightness(10);
  width: 1rem;
  height: 1rem;
  margin-right: 1rem;
}
.cashier-modal .modal-dialog .modal-inner-card {
  background: var(--socialLinksBg);
  padding: 1rem;
  border-radius: 0.625rem;
  color: var(--authSocailTextColor);
}
.cashier-modal .modal-dialog .modal-inner-card p {
  margin-bottom: 16px;
  line-height: 1.6;
  color: var(--authSocailTextColor);
  font-size: 0.865rem;
  font-weight: 500;
  font-style: normal;
  padding-right: 2rem;
}
.cashier-modal .modal-dialog .modal-inner-card .qr-code canvas {
  border: 5px solid var(--white);
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-inner-card .qr-code {
    margin-bottom: 2rem;
    text-align: center;
  }
}
.cashier-modal .modal-dialog .modal-inner-card .qr-code img {
  width: 100%;
}
.cashier-modal .modal-dialog .modal-inner-card .change-username label {
  text-transform: uppercase;
  color: var(--white);
  font-size: 0.875rem;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-inner-card .change-username label {
    font-size: 0.75rem;
  }
}
.cashier-modal .modal-dialog .modal-inner-card .change-username label span {
  color: var(--loss);
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .form-group {
  position: relative;
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .form-group .btn-secondary {
  position: absolute;
  right: 0.625rem;
  top: 1.95rem;
  min-height: 1.875rem;
  font-size: 0.813rem;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-inner-card .change-username .form-group .form-control {
    padding-right: 10rem;
  }
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .form-group .form-control:focus {
  border-color: var(--secondaryBtnBorder);
}
.cashier-modal .modal-dialog .modal-inner-card .change-username p {
  color: var(--white);
  text-transform: uppercase;
  font-size: 0.875rem;
  line-height: 1.75rem;
  font-weight: 700;
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .form-text-wrap {
  margin: 0.313rem 0;
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .form-text-wrap p {
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.063;
  color: var(--authSocailTextColor);
  text-transform: capitalize;
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .btn-primary {
  background: var(--socialLinksBg);
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .btn-primary:hover {
  background: var(var(--secondaryBtn));
}
.cashier-modal .modal-dialog .modal-inner-card .currency-converter .form-group img {
  position: absolute;
  left: 1rem;
  top: 1rem;
  height: 20px;
  width: 20px;
}
.cashier-modal .modal-dialog .modal-inner-card .currency-converter .form-group input {
  padding-left: 2.5rem;
}
.cashier-modal .modal-dialog .modal-inner-card .currency-converter span {
  padding: 0 1rem;
  color: var(--white);
}
.cashier-modal .modal-dialog .modal-inner-card .currency-converter button > span {
  padding: 0;
}
.cashier-modal .modal-dialog .modal-inner-card .payment-left-card h4 {
  line-height: 1.6;
  font-size: 0.875rem;
  font-weight: 500;
  font-style: normal;
}
.cashier-modal .modal-dialog .modal-inner-card .payment-card-right img {
  width: 3rem;
  margin: 0 0.313rem;
}
.cashier-modal .modal-dialog .bitcoin-instruction-list {
  margin-top: 1.2rem;
}
.cashier-modal .modal-dialog .bitcoin-instruction-list li {
  font-size: 0.865rem;
  font-weight: 500;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-btn-wrap {
    margin-top: 1rem;
  }
}
.cashier-modal .modal-dialog .modal-btn-wrap .btn {
  font-size: 0.75rem;
  margin-left: 0.625rem;
  line-height: 1rem;
  height: 46px;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-btn-wrap .btn {
    width: 100%;
    margin-left: 0;
    margin-bottom: 1rem;
  }
}
.cashier-modal .modal-dialog .coupon-section {
  text-align: center;
}
.cashier-modal .modal-dialog .coupon-section img {
  width: 8rem;
  height: 8rem;
  margin: 0 auto;
}
.cashier-modal .modal-dialog .coupon-section h4 {
  color: var(--white);
  font-weight: 700;
}
.cashier-modal .modal-dialog .coupon-section .form-group {
  max-width: 220px;
  margin: 1.5rem auto;
}
.cashier-modal .modal-dialog .coupon-section p {
  color: var(--white);
  font-weight: 500;
}
.cashier-modal .modal-dialog .coupon-section p a {
  color: var(--headingLink);
  padding-left: 0.2rem;
  display: inline-block;
}
.cashier-modal .modal-dialog .coupon-section .btn {
  min-width: 140px;
  margin: 1rem auto;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .nav-pills {
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
    margin-top: 1.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .btn-info {
    font-size: 0.75rem;
  }
}
.cashier-modal .modal-dialog .modal-content {
  height: 100%;
}
.cashier-modal .error-msg {
  margin: 0;
  position: absolute;
}

.cashier-btn .nav {
  gap: 0.75rem;
}
.cashier-btn .nav .nav-item .nav-link {
  background-color: var(--authTabBtn);
  border: 2px solid var(--authTabBtn);
  border-radius: 0.625rem;
  color: var(--authTabBtnText);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.75rem;
  padding: 0.375rem 1.625rem;
}
.cashier-btn .nav .nav-item .nav-link:hover {
  background-color: var(--headerBtnHover);
  border: 2px solid var(--headerBtnHover);
  color: var(--authTabActiveBorder);
}
.cashier-btn .nav .nav-item .nav-link.active, .cashier-btn .nav .nav-item .nav-link.active:hover {
  background-color: var(--authTabBtn);
  border: 2px solid var(--authTabActiveBorder);
  color: var(--authTabActiveBorder) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Header/header.scss"],"names":[],"mappings":"AAAA;EACE,MAAA;EACA,QAAA;EACA,YAAA;EACA,SAAA;AACF;;AAEA;;EAEE,4BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,6BAAA;EAEA,8CAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;AAAF;AAGI;EACE,YAAA;AADN;AAGM;EAHF;IAII,WAAA;IACA,YAAA;EAAN;AACF;AAIE;EACE,WAAA;AAFJ;AAOI;EACE,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALN;AAOM;EACE,qCAAA;AALR;AAQM;EACE,2BAAA;EACA,YAAA;AANR;AAQQ;EACE,2CAAA;EAEA,mBAAA;AAPV;AAUQ;EACE;IACE,uBAAA;EARV;AACF;AAeI;EACE,eAAA;EACA,cAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAbN;AAeM;EACE,oBAAA;AAbR;AAgBM;EACE,iCAAA;AAdR;AAgBQ;EACE,wBAAA;AAdV;AAsBM;EADF;IAEI,cAAA;EAnBN;AACF;AAwBI;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,yBAAA;AAtBN;AAwBM;EACE,yBAAA;EACA,kCAAA;EACA,gCAAA;AAtBR;AAyBM;EAZF;IAaI,mBAAA;EAtBN;AACF;AAwBM;EAhBF;IAiBI,eAAA;IACA,kBAAA;EArBN;AACF;AAwBI;EACE,gBAAA;AAtBN;AAwBM;EAHF;IAII,mBAAA;EArBN;AACF;AAuBM;EAPF;IAQI,eAAA;IACA,kBAAA;EApBN;AACF;AAwBE;EACE,WAAA;EAEA,mBAAA;EACA,uBAAA;EACA,UAAA;AAvBJ;AAyBI;EACE,cAAA;EACA,aAAA;AAvBN;AA0BI;EACE,iCAAA;EACA,mCAAA;EACA,kBAAA;AAxBN;AA4BM;EACE,kBAAA;AA1BR;AAgCI;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA9BN;AAgCM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AA9BR;AAgCQ;EACE,uBAAA;AA9BV;AAgCU;EACE,YAAA;AA9BZ;AAmCU;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;AAjCZ;AAoCU;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;AAlCZ;AAsCQ;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;AApCV;AAsCU;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AApCZ;AAuCU;EACE,4BAAA;AArCZ;AAuCY;EACE,uBAAA;EACA,qCAAA;AArCd;AA0CQ;EACE,sBAAA;AAxCV;AA0CU;EACE,YAAA;EACA,WAAA;EACA,SAAA;AAxCZ;AA8CQ;EACE,gCAAA;AA5CV;AA8CU;EACE,qCAAA;EACA,uCAAA;AA5CZ;AAoDI;EACE,uBAAA;AAlDN;AAoDM;EACE,WAAA;AAlDR;AAqDM;EACE,0DAAA;AAnDR;AAwDE;;EAEE,iBAAA;AAtDJ;AA0DI;EACE,wBAAA;EACA,kCAAA;EACA,uCAAA;AAxDN;AA0DM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,uCAAA;EACA,gBAAA;AAxDR;AA4DQ;EACE,iCAAA;AA1DV;AAgEE;EACE,aAAA;AA9DJ;AAgEI;EACE,kBAAA;AA9DN;AAgEM;EACE,kBAAA;EACA,gCAAA;AA9DR;AAgEQ;EACE,UAAA;AA9DV;AAkEM;EACE,4CAAA;AAhER;AAkEQ;EACE,wBAAA;AAhEV;;AAuEA;EACE,iBAAA;AApEF;AAsEE;EACE,2CAAA;AApEJ;AAsEI;EACE,aAAA;AApEN;AAsEM;EACE,6BAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AApER;AAsEQ;EAEE,8BAAA;AArEV;AAuEU;EACE,sBAAA;AArEZ;AAyEQ;EACE,oBAAA;EACA,WAAA;AAvEV;AA4EQ;EADF;IAEI,UAAA;EAzER;AACF;AA2EQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAzEV;AA2EU;EACE,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAzEZ;AA6EQ;EACE,SAAA;EACA,eAAA;AA3EV;AA6EU;EACE,YAAA;AA3EZ;AAgFU;EACE,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kCAAA;EACA,eAAA;AA9EZ;AAgFY;EACE,iCAAA;AA9Ed;AAiFY;EAIE,sCAAA;EACA,6BAAA;AAlFd;AAsFU;EArBF;IAsBI,8BAAA;EAnFV;EAqFU;IACE,WAAA;EAnFZ;AACF;AAuFQ;EACE,mBAAA;AArFV;AAwFU;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAtFZ;AA4FY;EADF;IAEI,uBAAA;EAzFZ;AACF;AA+FY;EADF;IAEI,cAAA;EA5FZ;AACF;AAiGM;EACE,gBAAA;EACA,SAAA;EACA,6BAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA/FR;;AAsGE;EADF;IAEI,cAAA;EAlGF;AACF;;AAqGA;EACE,4BAAA;AAlGF;;AAqGA;EACE;IACE,iBAAA;EAlGF;AACF;AAqGA;EACE,aAAA;EACA,UAAA;AAnGF;;AAsGA;EACE,qBAAA;EACA,6BAAA;AAnGF;;AAsGA;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,YAAA;AAnGF;AAqGE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAnGJ;AAsGE;EACE,YAAA;AApGJ;AAsGI;EAHF;IAII,WAAA;EAnGJ;AACF;AAqGI;EACE,yBAAA;AAnGN;AAqGM;EACE,kBAAA;EACA,gCAAA;EACA,QAAA;EACA,SAAA;AAnGR;AAuGI;EACE,gBAAA;AArGN;AAyGE;EAtCF;IAuCI,WAAA;EAtGF;AACF;AAwGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4CAAA;EACA,aAAA;AAtGJ;AAwGI;EACE,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AAtGN;AA0GM;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAxGR;AA0GQ;EACE,eAAA;AAxGV;AAiHI;EACE,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AA/GN;AAqHM;EACE,sBAAA;AAnHR;AAsHM;EAEE,yBAAA;EACA,uBAAA;EACA,mBAAA;AArHR;AAyHI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAvHN;AAyHM;EARF;IASI,gBAAA;EAtHN;AACF;AAwHM;EAEE,qCAAA;EACA,uBAAA;EACA,mBAAA;AAvHR;AA2HI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mCAAA;AAzHN;AA2HM;EAEE,0BAAA;EACA,uCAAA;EACA,gCAAA;AA1HR;AA8HI;EACE,uBAAA;EACA,UAAA;EAIA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AA/HN;AAiIM;EAEE,uBAAA;EACA,yBAAA;EACA,yBAAA;AAhIR;AAoII;EACE,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EAEA,kBAAA;AAnIN;AAqIM;EAEE,uBAAA;EACA,yBAAA;AApIR;AAuIU;EACE,0BAAA;AArIZ;AAwIU;EACE,wBAAA;AAtIZ;AA2IM;EA7BF;IA8BI,aAAA;EAxIN;AACF;AA4IM;EACE,qBAAA;AA1IR;AA8II;EACE,eAAA;EACA,gBAAA;AA5IN;AA8IM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;AA5IR;AA8IQ;EACE,WAAA;EACA,iBAAA;AA5IV;AAkJE;EACE,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAhJJ;AAkJI;EACE,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;AAhJN;AAmJI;EACE,mBAAA;EACA,mBAAA;AAjJN;AAqJE;EAKE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,2CAAA;AAvJJ;AAyJI;EAdF;IAeI,2BAAA;EAtJJ;AACF;AAwJI;EAlBF;IAmBI,2BAAA;EArJJ;AACF;AAuJI;EACE,WAAA;EACA,YAAA;AArJN;AAwJI;EACE,8BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAtJN;AAwJM;EACE,gBAAA;AAtJR;AAyJM;EACE,cAAA;EACA,kBAAA;AAvJR;AA0JM;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AAxJR;AA2JM;EACE,YAAA;EACA,iBAAA;AAzJR;AA4JM;EA/BF;IAgCI,WAAA;IACA,2BAAA;EAzJN;AACF;AA2JM;EACE,iBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAzJR;AA2JQ;EACE,gBAAA;EACA,uBAAA;EACA,eAAA;AAzJV;AA6JU;EAEE,gBAAA;AA5JZ;AA+JU;EACE,mBAAA;EACA,gBAAA;AA7JZ;AAgKU;EACE,0BAAA;AA9JZ;AAkKQ;EACE,WAAA;EACA,sBAAA;AAhKV;AAmKQ;EACE,gBAAA;AAjKV;AAqKU;EACE,gBAAA;EACA,aAAA;AAnKZ;AAqKY;EACE,gBAAA;AAnKd;AAwKY;EACE,iBAAA;EACA,mBAAA;AAtKd;AA0KU;EAKE,gBAAA;AA5KZ;AA8KY;EACE,iBAAA;EACA,mBAAA;AA5Kd;AA+KY;EAEE,sBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA/Kd;AAkLY;EACE,oBAAA;EACA,eAAA;EACA,YAAA;AAhLd;AAqLQ;EACE,mBAAA;EACA,gBAAA;EACA,sBAAA;AAnLV;AAsLQ;EACE,0BAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AApLV;AAuLQ;EACE,+BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,eAAA;AArLV;AAyLU;EACE,aAAA;AAvLZ;AA6LI;EACE,QAAA;AA3LN;AA+LE;EACE,8BAAA;EACA,kBAAA;EACA,cAAA;AA7LJ;AA+LI;EALF;IAMI,4BAAA;EA5LJ;AACF;AA8LI;EACE,kBAAA;AA5LN;AA8LM;EACE,2CAAA;EAEA,8BAAA;EACA,+CAAA;EACA,kCAAA;EACA,qBAAA;EACA,uBAAA;EACA,iCAAA;EACA,2CAAA;AA7LR;AAkMQ;EACE,aAAA;EACA,mBAAA;AAhMV;AAmMU;EACE,8BAAA;AAjMZ;AAuMQ;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;AArMV;AAuMU;EACE,uBAAA;EACA,wBAAA;AArMZ;AAwMU;EACE,wBAAA;AAtMZ;AA0MQ;EACE,6BAAA;EACA,wCAAA;AAxMV;AA4MM;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AA1MR;AA4MQ;EACE,eAAA;EACA,gBAAA;AA1MV;AA+MI;EACE,oBAAA;AA7MN;AA+MM;EACE,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AA7MR;AAiNM;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA/MR;AAkNM;EACE,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AAhNR;AAkNQ;EACE,eAAA;AAhNV;AAoNM;EACE,sCAAA;EACA,YAAA;EACA,kBAAA;AAlNR;AAoNQ;EACE,iCAAA;AAlNV;AAqNY;EACE,0BAAA;AAnNd;AAyNM;EACE,uCAAA;EACA,aAAA;EACA,eAAA;EACA,iCAAA;AAvNR;AAyNQ;EACE,kBAAA;AAvNV;AAyNU;EACE,iCAAA;AAvNZ;AAyNY;EACE,0BAAA;AAvNd;AAyNc;EACE,uBAAA;EACA,mBAAA;AAvNhB;AA8NM;EACE,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AA5NR;AA8NQ;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EAEA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AA7NV;AAgOQ;;EAEE,WAAA;EACA,kBAAA;EACA,kBAAA;AA9NV;AAiOQ;EACE,UAAA;EACA,4KAAA;EAKA,uGAAA;AAlOV;AAuOQ;EACE,+BAAA;EACA,oBAAA;EACA,+EAAA;AArOV;AAwOQ;EACE,yBAAA;AAtOV;AAyOQ;EACE,0BAAA;AAvOV;AA0OQ;EACE,aAAA;AAxOV;AA2OQ;EACE;IACE,MAAA;EAzOV;AACF;AA6OM;EACE,WAAA;EACA,mBAAA;AA3OR;AA8OM;EACE,2BAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA5OR;AA8OQ;EAGE,4CAAA;EACA,YAAA;EACA,mBAAA;AA9OV;AAkPM;EACE,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAhPR;AAoPI;EACE,uBAAA;EACA,iCAAA;EACA,UAAA;EACA,cAAA;AAlPN;;AAwPE;EACE,4BAAA;AArPJ;AAwPE;EACE,kDAAA;EACA,8CAAA;EACA,qBAAA;AAtPJ;;AA0PA;EACE,mBAAA;AAvPF;AAyPE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvPJ;AAyPI;EAbF;IAcI,eAAA;IACA,aAAA;EAtPJ;AACF;AAwPI;EACE,UAAA;AAtPN;AAyPI;EACE,eAAA;EACA,gBAAA;AAvPN;AA2PE;EACE,gBAAA;AAzPJ;AA2PI;EAHF;IAII,eAAA;IACA,iBAAA;IACA,SAAA;EAxPJ;AACF;AA2PE;EACE,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;AAzPJ;AA2PI;EACE,0BAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAzPN;AA4PI;EACE,cAAA;EACA,kBAAA;EACA,2BAAA;EACA,4CAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,qBAAA;AA1PN;AA4PM;EACE,eAAA;EACA,gBAAA;AA1PR;AA8PI;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,uCAAA;EACA,uBAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;AA5PN;AA8PM;EACE,eAAA;AA5PR;AAgQI;EACE,SAAA;AA9PN;AAgQM;EACE,WAAA;AA9PR;AAmQE;EACE,6BAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AAjQJ;AAoQM;EACE,iCAAA;EACA,mBAAA;EACA,gBAAA;AAlQR;AAqQM;EACE,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAnQR;AAyQI;EACE,mBAAA;EACA,iCAAA;EACA,gBAAA;AAvQN;AAyQM;EACE,uBAAA;EACA,iBAAA;EACA,gBAAA;AAvQR;AA4QE;EACE,kBAAA;AA1QJ;AA4QI;EACE,YAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AA1QN;AA4QM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AA1QR;AA+QM;EACE,kBAAA;EACA,4BAAA;EACA,gBAAA;AA7QR;AAgRM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA9QR;AAmRE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAjRJ;AAqRE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAnRJ;AA8RI;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;AA5RN;AAgSE;EACE,eAAA;EACA,gBAAA;AA9RJ;AAiSI;EACE,WAAA;EACA,eAAA;EACA,YAAA;AA/RN;AAmSE;EACE,iBAAA;EACA,6BAAA;EACA,mBAAA;EACA,WAAA;AAjSJ;;AAqSA;EACE,gBAAA;AAlSF;AAoSE;EACE;IACE,kBAAA;EAlSJ;AACF;;AAwSI;EADF;IAEI,kBAAA;EApSJ;AACF;AAsSI;EACE,2BAAA;EACA,eAAA;AApSN;AAwSE;EAZF;IAaI,yBAAA;EArSF;AACF;;AAySE;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;AAtSJ;AAySE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAvSJ;;AA4SE;EACE,2BAAA;AAzSJ;AA2SI;EACE,mBAAA;EACA,iCAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;AAzSN;AA6SM;EACE,kBAAA;AA3SR;AA6SQ;EACE,WAAA;AA3SV;AA8SQ;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AA5SV;AA8SU;EACE,yBAAA;EACA,0BAAA;AA5SZ;AA8SY;EACE,qBAAA;EACA,eAAA;AA5Sd;AAgTU;EACE,eAAA;AA9SZ;AAkTQ;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;AAhTV;AAoTM;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AAlTR;AAwTI;EACE,oCAAA;AAtTN;;AA4TE;EACE,gBAAA;EACA,gBAAA;AAzTJ;AA2TI;EAJF;IAKI,eAAA;IACA,eAAA;EAxTJ;AACF;AA0TI;EACE,gBAAA;AAxTN;AA0TM;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;AAxTR;AA2TM;;EAEE,kBAAA;AAzTR;AA4TM;EACE,yBAAA;EACA,eAAA;EACA,2BAAA;AA1TR;;AAiUE;EACE,uBAAA;AA9TJ;;AAmUE;EACE,gBAAA;AAhUJ;AAkUI;EAHF;IAII,eAAA;IACA,SAAA;IACA,iBAAA;EA/TJ;AACF;AAkUI;EACE,aAAA;AAhUN;AAkUM;EAHF;IAII,sBAAA;EA/TN;AACF;AAiUM;EACE,iCAAA;EACA,YAAA;AA/TR;AAkUM;;;;EAIE,mBAAA;EACA,8BAAA;AAhUR;AAoUQ;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AAlUV;AAoUU;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AAlUZ;AAoUY;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAlUd;AAsUU;EACE,mBAAA;EACA,SAAA;EACA,eAAA;AApUZ;AAuUU;EACE,iCAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AArUZ;AA2UI;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;AAzUN;AA2UM;EALF;IAMI,sBAAA;IACA,uBAAA;EAxUN;AACF;AA0UM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAxUR;AA2UM;EACE,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAzUR;AA4UM;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA1UR;AA4UQ;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AA1UV;AA8UM;EACE,UAAA;AA5UR;AA8UQ;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA5UV;AAiVI;EACE,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,iCAAA;AA/UN;AAiVM;EACE,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA/UR;AAmVQ;EACE,8BAAA;AAjVV;AAoVQ;EALF;IAMI,mBAAA;IACA,kBAAA;EAjVR;AACF;AAmVQ;EACE,WAAA;AAjVV;AAsVQ;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;AApVV;AAsVU;EALF;IAMI,kBAAA;EAnVV;AACF;AAqVU;EACE,kBAAA;AAnVZ;AAuVQ;EACE,kBAAA;AArVV;AAuVU;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AArVZ;AAyVY;EADF;IAEI,oBAAA;EAtVZ;AACF;AAwVY;EACE,uCAAA;AAtVd;AA2VQ;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAzVV;AA4VQ;EACE,kBAAA;AA1VV;AA4VU;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,0BAAA;AA1VZ;AA8VQ;EACE,gCAAA;AA5VV;AA8VU;EACE,oCAAA;AA5VZ;AAmWU;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AAjWZ;AAoWU;EACE,oBAAA;AAlWZ;AAsWQ;EACE,eAAA;EACA,mBAAA;AApWV;AAuWQ;EACE,UAAA;AArWV;AA0WQ;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAxWV;AA6WQ;EACE,WAAA;EACA,kBAAA;AA3WV;AAgXI;EACE,kBAAA;AA9WN;AAgXM;EACE,mBAAA;EACA,gBAAA;AA9WR;AAmXM;EADF;IAEI,gBAAA;EAhXN;AACF;AAkXM;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AAhXR;AAkXQ;EANF;IAOI,WAAA;IACA,cAAA;IACA,mBAAA;EA/WR;AACF;AAmXI;EACE,kBAAA;AAjXN;AAmXM;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAjXR;AAoXM;EACE,mBAAA;EACA,gBAAA;AAlXR;AAqXM;EACE,gBAAA;EACA,mBAAA;AAnXR;AAsXM;EACE,mBAAA;EACA,gBAAA;AApXR;AAsXQ;EACE,yBAAA;EACA,oBAAA;EACA,qBAAA;AApXV;AAwXM;EACE,gBAAA;EACA,iBAAA;AAtXR;AA2XM;EADF;IAEI,iBAAA;IACA,gBAAA;IACA,WAAA;IACA,kBAAA;EAxXN;AACF;AA4XM;EADF;IAEI,kBAAA;EAzXN;AACF;AA4XI;EACE,YAAA;AA1XN;AA8XE;EACE,SAAA;EACA,kBAAA;AA5XJ;;AAiYE;EACE,YAAA;AA9XJ;AAiYM;EACE,mCAAA;EACA,mCAAA;EACA,uBAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,0BAAA;AA/XR;AAiYQ;EACE,uCAAA;EACA,uCAAA;EACA,iCAAA;AA/XV;AAkYQ;EAEE,mCAAA;EACA,4CAAA;EACA,4CAAA;AAjYV","sourcesContent":[":root {\n  --p: 0;\n  --b: 2px;\n  --c: #ff4949;\n  --w: 16px;\n}\n\n.nav-link.cta-btn:hover,\n.nav-link.cta-btn.active {\n  background: var(--darkSlate);\n  color: var(--white);\n}\n\n.modal-backdrop {\n  display: none;\n}\n\nheader {\n  background: var(--theme-dark);\n  // box-shadow: var(--shadows-lg);\n  border-bottom: 1px solid var(--sidebarTooltip);\n  position: relative;\n  padding: 0 1rem;\n  z-index: 11;\n  padding-right: 14px;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  min-height: 76px;\n\n  .brand-logo {\n    svg {\n      width: 158px;\n\n      @media screen and (max-width: 1199.98px) {\n        width: 50px;\n        height: 50px;\n      }\n    }\n  }\n\n  .header-middile-btn {\n    gap: 0.5rem;\n    // position: absolute;\n    // transform: translate(-50%, -50%);\n    // left: 50%;\n    // top: 50%;\n    .btn-primary {\n      background: var(--socialLinksBg);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      &:hover {\n        background: var(--sidebarBtnGradient);\n      }\n\n      &.currencies-btn {\n        background: var(--darkGray);\n        border: none;\n\n        &:hover {\n          background: var(--socialLinksBg) !important;\n          // border-color: var(--socialLinksBg) !important;\n          color: var(--white);\n        }\n\n        @media screen and (max-width: 575.98px) {\n          & {\n            padding: 0.25rem 0.5rem;\n          }\n        }\n      }\n    }\n  }\n\n  .header-social-links {\n    a {\n      height: 2.75rem;\n      width: 2.75rem;\n      border-radius: 0.625rem;\n      background: var(--sidebarTooltip);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n\n      &:not(:last-child) {\n        margin-right: 0.5rem;\n      }\n\n      &:hover {\n        background: var(--headerBtnHover);\n\n        svg {\n          fill: var(--headingLink);\n        }\n      }\n    }\n  }\n\n  &.sidebar-close {\n    .brand-logo {\n      @media only screen and (min-width: 768px) and (max-width: 1480.98px) {\n        margin-left: 0;\n      }\n    }\n  }\n\n  .auth-btn {\n    &.btn-primary {\n      min-width: 120px;\n      border: 1px solid var(--headingLink);\n      background: transparent;\n      color: var(--headingLink);\n\n      &:hover {\n        color: var(--headingLink);\n        background: transparent !important;\n        border-color: var(--headingLink);\n      }\n\n      @media screen and (max-width: 991.98px) {\n        font-size: 0.875rem;\n      }\n\n      @media screen and (max-width: 767.98px) {\n        min-width: 70px;\n        font-size: 0.75rem;\n      }\n    }\n\n    &.btn-secondary {\n      min-width: 120px;\n\n      @media screen and (max-width: 991.98px) {\n        font-size: 0.875rem;\n      }\n\n      @media screen and (max-width: 767.98px) {\n        min-width: 70px;\n        font-size: 0.75rem;\n      }\n    }\n  }\n\n  .search-btn {\n    width: 45px;\n    // display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n\n    & svg {\n      height: 1.2rem;\n      width: 1.2rem;\n    }\n\n    &.btn-primary {\n      background: var(--sidebarTooltip);\n      border-color: var(--sidebarTooltip);\n      position: relative;\n    }\n\n    .theme-modal {\n      .modal-dialog {\n        position: relative;\n      }\n    }\n  }\n\n  .reward-menu-wrap {\n    .reward-menu {\n      min-width: 415px;\n      left: -60% !important;\n      padding-top: 1.2rem;\n      max-height: calc(100dvh - 38rem);\n      overflow-x: hidden;\n      overflow-y: auto;\n      min-height: 200px;\n\n      .dropdown-item {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        background: transparent;\n        padding: 0.313rem 0;\n\n        &:hover {\n          background: transparent;\n\n          img {\n            filter: none;\n          }\n        }\n\n        .reward-menu-content {\n          h4 {\n            font-size: 0.875rem;\n            text-transform: uppercase;\n            padding-bottom: 0.1rem;\n          }\n\n          p {\n            font-size: 0.75rem;\n            font-weight: 300;\n            color: var(--liveGreen);\n          }\n        }\n\n        .btn {\n          height: auto;\n          padding: 0.2rem 1rem;\n          font-size: 0.75rem;\n\n          & svg {\n            width: 1rem;\n            height: 1rem;\n            margin-right: 0.313rem;\n          }\n\n          &.btn-green {\n            background: var(--liveGreen);\n\n            &:hover {\n              background: transparent;\n              border-color: var(--primaryBtnBorder);\n            }\n          }\n        }\n\n        .reward-menu-icon {\n          margin-right: 0.313rem;\n\n          & svg {\n            height: 3rem;\n            width: 3rem;\n            margin: 0;\n          }\n        }\n      }\n\n      .dropdown-btn-wrap {\n        .btn-primary {\n          background: var(--socialLinksBg);\n\n          &:hover {\n            background: var(--secondaryRadialBtn);\n            border-color: var(--secondaryBtnBorder);\n          }\n        }\n      }\n    }\n  }\n\n  .provider-list {\n    .casino-search {\n      background: transparent;\n\n      & .search-icon {\n        top: 0.9rem;\n      }\n\n      & input {\n        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.19) !important;\n      }\n    }\n  }\n\n  .header-toggle-icon,\n  .header-user-menu {\n    margin-left: 1rem;\n  }\n\n  .reward-btn {\n    .btn-primary {\n      padding: 0.625rem 0.5rem;\n      background: var(--primaryGradient);\n      border: 1px solid var(--sidebarTooltip);\n\n      .dropdown-icon {\n        width: 24px;\n        height: 24px;\n        border-radius: 0.5rem;\n        background-color: var(--sidebarTooltip);\n        line-height: 1.6;\n      }\n\n      &:hover {\n        .dropdown-icon {\n          background-color: var(--selectBg);\n        }\n      }\n    }\n  }\n\n  .top-header-right {\n    display: flex;\n\n    .btn-primary {\n      position: relative;\n\n      svg {\n        position: absolute;\n        transform: translate(-50%, -50%);\n\n        &:nth-child(2) {\n          opacity: 0;\n        }\n      }\n\n      &:hover {\n        background: var(--headerBtnHover) !important;\n\n        svg {\n          fill: var(--headingLink);\n        }\n      }\n    }\n  }\n}\n\n.search-dilog {\n  max-width: 1408px;\n\n  .search-modal {\n    background-color: var(--inputbg) !important;\n\n    .search-modal-wrap {\n      padding: 2rem;\n\n      .nav-link {\n        background: var(--authTabBtn);\n        min-width: 100%;\n        width: 100%;\n        margin: 0;\n        justify-content: flex-start;\n        border: none;\n        font-size: 0.875rem;\n        font-weight: 500;\n        border-radius: 0;\n        padding: 0.6rem 1rem;\n        min-height: 2.5rem;\n\n        &.active,\n        &:hover {\n          background: var(--profileCard);\n\n          & img {\n            filter: brightness(10);\n          }\n        }\n\n        & img {\n          margin-right: 0.8rem;\n          width: 1rem;\n        }\n      }\n\n      .search-modal-right-section {\n        @media screen and (max-width: 767.98px) {\n          padding: 0;\n        }\n\n        .search-modal-heading {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          margin-bottom: 1rem;\n\n          h4 {\n            color: var(--white);\n            margin: 0;\n            font-weight: 700;\n            text-transform: uppercase;\n            font-size: 1.375rem;\n          }\n        }\n\n        .casino-search {\n          flex: 1;\n          margin-right: 0;\n\n          input {\n            height: 40px;\n          }\n        }\n\n        .search-filter-right {\n          .btn-primary {\n            font-size: 0.875rem;\n            min-height: 2.75rem;\n            background: var(--socialLinksBg);\n            border-color: var(--socialLinksBg);\n            cursor: pointer;\n\n            span {\n              color: var(--authTabActiveBorder);\n            }\n\n            &:hover,\n            &:active,\n            &.show,\n            &:visited {\n              background: var(--darkGray) !important;\n              border-color: var(--darkGray);\n            }\n          }\n\n          @media screen and (max-width: 767.98px) {\n            justify-content: space-between;\n\n            & .btn {\n              width: 100%;\n            }\n          }\n        }\n\n        .global-casino-section {\n          padding: 0 0.625rem;\n\n          // margin: 1rem 0;\n          .theme-card-wrap {\n            margin: 0.5rem 0;\n            width: 100%;\n            min-width: 100%;\n          }\n        }\n\n        .load-more-wrap {\n          .btn {\n            @media screen and (max-width: 767.98px) {\n              justify-content: center;\n            }\n          }\n        }\n\n        .global-casino-section {\n          .col-lg-2 {\n            @media screen and (min-width: 1200px) {\n              width: 14.285%;\n            }\n          }\n        }\n      }\n\n      .profile-tabs {\n        position: sticky;\n        top: 1rem;\n        background: var(--authTabBtn);\n        border-radius: 0.625rem;\n        padding: 0;\n        overflow: hidden;\n        max-width: 190px;\n        margin-right: 2rem;\n      }\n    }\n  }\n}\n\n.auth-modal-wrap {\n  @media screen and (max-width: 1199.98px) {\n    min-width: 80%;\n  }\n}\n\n.casino-header {\n  padding: 20px 15px 20px 75px;\n}\n\n@media screen and (max-width: 767.98px) {\n  .currency-wrapper .btn-wallet {\n    padding: 4px 11px;\n  }\n}\n\nheader .menuBtn {\n  display: none;\n  z-index: 1;\n}\n\nheader .menuBtn.toggleBtn {\n  transform: scaleX(-1);\n  -webkit-transform: scaleX(-1);\n}\n\n.chat-sidebar {\n  position: fixed;\n  right: 0;\n  top: 4.75rem;\n  background: var(--theme-dark);\n  height: calc(100dvh - 50px);\n  width: 248px;\n\n  & .chat-content {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  &.chat-collapse {\n    width: 340px;\n\n    @media screen and (max-width: 767.98px) {\n      width: 100%;\n    }\n\n    .chat-collapse-icon {\n      transform: rotate(180deg);\n\n      svg {\n        position: absolute;\n        transform: translate(-50%, -50%);\n        top: 50%;\n        left: 50%;\n      }\n    }\n\n    .btn-secondary {\n      min-width: 110px;\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    width: 100%;\n  }\n\n  .chat-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--theme-border);\n    padding: 16px;\n\n    .chat-btn {\n      background: var(--headerBtnHover) !important;\n      display: flex;\n      align-items: center;\n      width: 4.75rem !important;\n      justify-content: center;\n    }\n\n    .language-btn {\n      a {\n        color: var(--white);\n        font-weight: 600;\n        font-size: 0.75rem;\n        display: flex;\n        align-items: center;\n\n        i {\n          font-size: 1rem;\n        }\n      }\n    }\n\n    // .chat-close-wrap {\n    //   width: 60px;\n    // }\n\n    .btn-primary {\n      background: transparent;\n      border: none;\n      width: 100%;\n      font-size: 0.74rem;\n      margin: 0rem 0.213rem;\n      padding: 0rem 0.45rem;\n      box-shadow: none;\n      color: var(--chatText);\n      min-height: 2.25rem;\n      font-weight: 500;\n\n      // @media screen and (max-width: 767.98px) {\n      //   min-width: 140px;\n      // }\n\n      & svg {\n        margin-right: 0.313rem;\n      }\n\n      &.active,\n      &:hover {\n        border-color: transparent;\n        background: transparent;\n        color: var(--white);\n      }\n    }\n\n    .btn-secondary {\n      height: 2.375rem;\n      width: 100%;\n      font-size: 0.74rem;\n      margin: 0 0.313rem;\n      padding: 0.25rem 0.625rem;\n      box-shadow: none;\n\n      @media screen and (max-width: 767.98px) {\n        min-width: 140px;\n      }\n\n      &.active,\n      &:hover {\n        border-color: var(--primaryBtnBorder);\n        background: transparent;\n        color: var(--white);\n      }\n    }\n\n    &>a {\n      width: 100%;\n      color: var(--white);\n      text-align: center;\n      font-size: 0.74rem;\n      background: var(--authTabBtn);\n      min-height: 2.375rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 0.625rem;\n      margin: 0 0.313rem;\n      border: 1px solid var(--authTabBtn);\n\n      &.active,\n      &:hover {\n        background: var(--inputbg);\n        border-color: var(--secondaryBtnBorder);\n        color: var(--secondaryBtnBorder);\n      }\n    }\n\n    .chat-close {\n      background: transparent;\n      padding: 0;\n      // margin: 0 0.2rem;\n      // width: 1.5rem;\n      // flex: 0 0 1.5rem;\n      align-items: center;\n      display: flex;\n      justify-content: center;\n      border: none;\n      position: relative;\n      color: var(--chatIcon);\n\n      &.active,\n      &:hover {\n        background: transparent;\n        border-color: transparent;\n        color: var(--headingLink);\n      }\n    }\n\n    .chat-collapse-icon {\n      background: transparent;\n      padding: 0;\n      margin: 0 0.2rem;\n      width: 5rem;\n      align-items: center;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border: none;\n      // flex: 0 0 2rem;\n      position: relative;\n\n      &.active,\n      &:hover {\n        background: transparent;\n        border-color: transparent;\n\n        svg {\n          path:nth-child(1) {\n            stroke: var(--headingLink);\n          }\n\n          path:nth-child(2) {\n            fill: var(--headingLink);\n          }\n        }\n      }\n\n      @media screen and (max-width: 991.98px) {\n        display: none;\n      }\n    }\n\n    .dropdown-toggle {\n      &::after {\n        display: inline-block;\n      }\n    }\n\n    .dropdown-menu {\n      min-width: 100%;\n      padding: 0.25rem;\n\n      a {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        font-size: 0.75rem;\n        gap: 0.5rem;\n        padding: 0.25rem 0.5rem;\n        border-radius: 0.25rem;\n\n        img {\n          width: 18px;\n          object-fit: cover;\n        }\n      }\n    }\n  }\n\n  .chat-announcement-card {\n    background: var(--headingLink);\n    border-radius: 0.313rem;\n    margin: 0.313rem 0;\n    padding: 0.625rem;\n    position: relative;\n\n    p {\n      color: var(--white);\n      font-size: 0.75rem;\n      margin: 0;\n      padding-right: 0.4rem;\n      line-height: 1.3;\n      word-break: break-all;\n    }\n\n    a {\n      color: var(--white);\n      font-size: 0.625rem;\n    }\n  }\n\n  .chat-content-scroll {\n    // height: calc(100vh - 250px);\n    // overflow-y: auto;\n    // margin-bottom: 22px;\n    // border-bottom: 2px solid var(--inputBorder);\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0%;\n    min-height: 0px;\n    overflow-wrap: break-word;\n    overflow: hidden auto;\n    margin-bottom: 30px;\n    border-bottom: 2px solid var(--inputBorder);\n\n    @media screen and (max-width: 1199.98px) {\n      height: calc(100vh - 315px);\n    }\n\n    @media screen and (max-width: 767.98px) {\n      height: calc(100vh - 315px);\n    }\n\n    .empty-chat {\n      width: 100%;\n      padding: 5px;\n    }\n\n    .chat-content-wrap {\n      padding: 1rem 1rem 0.5rem 1rem;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      position: relative;\n\n      .chat-bubble:nth-child(1) {\n        margin-top: auto;\n      }\n\n      .new_message {\n        color: #00a4fa;\n        text-align: center;\n      }\n\n      .new_message::before {\n        background-color: #00a4fa;\n        content: \"\";\n        display: inline-block;\n        height: 1px;\n        position: relative;\n        vertical-align: middle;\n        width: 100%;\n      }\n\n      .new_message::before {\n        right: 0.5em;\n        margin-left: -50%;\n      }\n\n      @media screen and (max-width: 767.98px) {\n        width: 100%;\n        height: calc(100vh - 260px);\n      }\n\n      .chat-card {\n        margin: 0.25rem 0;\n        border-radius: 0.5rem;\n        background: var(--chatCardBg);\n        padding: 0.75rem;\n        color: var(--white);\n        word-break: break-word;\n        position: relative;\n\n        h4 {\n          font-weight: 600;\n          padding-right: 0.313rem;\n          cursor: pointer;\n        }\n\n        p {\n          span {\n            // opacity: 0.8;\n            font-weight: 400;\n          }\n\n          .tagged-name {\n            color: var(--white);\n            font-weight: 400;\n          }\n\n          .chat-msg {\n            color: var(--listitemtext);\n          }\n        }\n\n        .user-icon {\n          width: 1rem;\n          margin-right: 0.313rem;\n        }\n\n        &:first-child {\n          margin-top: auto;\n        }\n\n        .chat-card-head {\n          .chat-badge-lising {\n            margin: 0 0.1rem;\n            display: flex;\n\n            svg {\n              margin: 0 0.1rem;\n            }\n          }\n\n          .chat-avtar {\n            img {\n              object-fit: cover;\n              border-radius: 12px;\n            }\n          }\n\n          .user-clr-one {\n            // color: var(--white);\n            // position: relative;\n            // top: -2px;\n            // margin-right: 4px;\n            margin-bottom: 0;\n\n            img {\n              object-fit: cover;\n              border-radius: 12px;\n            }\n\n            .chat-user-label {\n              // display: inline-block;\n              vertical-align: middle;\n              // max-width: 70px;\n              font-weight: 600;\n              font-size: 0.875rem;\n              color: var(--white);\n            }\n\n            .gif_img {\n              pointer-events: none;\n              cursor: default;\n              height: 75px;\n            }\n          }\n        }\n\n        .chat-time {\n          font-size: 0.625rem;\n          font-weight: 300;\n          color: var(--chatText);\n        }\n\n        .chat-text {\n          color: var(--listitemtext);\n          word-break: break-all;\n          font-size: 0.875rem;\n          line-height: 26px;\n        }\n\n        .report-user-wrap {\n          background: var(--userreportBg);\n          padding: 0.2rem;\n          min-width: 32px;\n          min-height: 30px;\n          align-items: center;\n          justify-content: center;\n          position: absolute;\n          right: 0.313rem;\n          top: 0;\n          display: none;\n          cursor: pointer;\n        }\n\n        &:hover {\n          .report-user-wrap {\n            display: flex;\n          }\n        }\n      }\n    }\n\n    &::-webkit-scrollbar {\n      width: 0;\n    }\n  }\n\n  .chat-bottom-section {\n    padding: 1rem 1rem 1.5rem 1rem;\n    position: relative;\n    top: -1.875rem;\n\n    @media screen and (max-width: 1199.98px) {\n      padding: 1rem 1rem 4rem 1rem;\n    }\n\n    .chat-typing {\n      position: relative;\n\n      textarea {\n        background-color: var(--inputbg) !important;\n        // height: 2.75rem !important;\n        font-size: 0.875rem !important;\n        border: 2px solid var(--inputBorder) !important;\n        padding-right: 4.375rem !important;\n        border-radius: 0.5rem;\n        margin-bottom: 0.625rem;\n        color: var(--authSocailTextColor);\n        font-family: \"Rubik\", sans-serif !important;\n        // top: -0.925rem !important;\n        // max-height: 10rem;\n        // overflow: auto;\n\n        &:focus {\n          outline: none;\n          color: var(--white);\n\n          // border-color: var(--primaryBtnBorder) !important;\n          &::placeholder {\n            color: var(--white) !important;\n          }\n        }\n      }\n\n      div {\n        .giphy-carousel {\n          width: 285px;\n          position: absolute;\n          bottom: 79px;\n          right: 0;\n\n          .giphy-gif {\n            width: 100px !important;\n            height: 100px !important;\n          }\n\n          .giphy-attribution {\n            display: none !important;\n          }\n        }\n\n        button {\n          border: 1px solid transparent;\n          background-color: transparent !important;\n        }\n      }\n\n      .chat-input-cta {\n        position: absolute;\n        z-index: 1;\n        right: 0.625rem;\n        bottom: 0.5rem;\n\n        svg {\n          cursor: pointer;\n          margin: 0 0.2rem;\n        }\n      }\n    }\n\n    .chat-details-wrap {\n      margin-top: 0.625rem;\n\n      & .btn {\n        min-height: 1.688rem;\n        padding: 0 0.5rem;\n        font-size: 0.74rem;\n        border-radius: 0.375rem;\n        // margin-left: 0.313rem;\n      }\n\n      & img {\n        margin-right: 0.313rem;\n        width: 0.875rem;\n        height: 0.875rem;\n        border-radius: 1rem;\n      }\n\n      a {\n        color: var(--listitemtext);\n        font-weight: 400;\n        font-size: 0.75rem;\n        display: flex;\n        gap: 5px;\n        padding: 0.45rem;\n        align-items: center;\n\n        i {\n          font-size: 1rem;\n        }\n      }\n\n      .chat-rules {\n        background-color: var(--socialLinksBg);\n        padding: 6px;\n        border-radius: 4px;\n\n        &:focus {\n          background: var(--headerBtnHover);\n\n          svg {\n            path {\n              stroke: var(--headingLink);\n            }\n          }\n        }\n      }\n\n      ul {\n        background-color: var(--sidebarTooltip);\n        padding: 12px;\n        min-width: 9rem;\n        box-shadow: var(--dropdownShadow);\n\n        li {\n          border-radius: 4px;\n\n          &:hover {\n            background: var(--headerBtnHover);\n\n            a {\n              color: var(--listitemtext);\n\n              &:hover {\n                background: transparent;\n                color: var(--white);\n              }\n            }\n          }\n        }\n      }\n\n      .progress-wrap {\n        border: 2px solid var(--c);\n        border-radius: 50%;\n        height: 14px;\n        width: 14px;\n        margin-right: 6px;\n\n        .pie {\n          width: var(--w);\n          aspect-ratio: 1;\n          position: relative;\n          display: inline-grid;\n          // margin:5px;\n          place-content: center;\n          font-size: 25px;\n          font-weight: bold;\n          font-family: sans-serif;\n        }\n\n        .pie:before,\n        .pie:after {\n          content: \"\";\n          position: absolute;\n          border-radius: 50%;\n        }\n\n        .pie:before {\n          inset: 2px;\n          background: radial-gradient(farthest-side, var(--c) 98%, #0000) top/var(--b) var(--b) no-repeat,\n            conic-gradient(var(--c) calc(var(--p) * 1%), #0000 0);\n          -webkit-mask: radial-gradient(farthest-side,\n              #0000 calc(99% - var(--b)),\n              #000 calc(100% - var(--b)));\n          mask: radial-gradient(farthest-side,\n              #0000 calc(99% - var(--b)),\n              #000 calc(100% - var(--b)));\n        }\n\n        .pie:after {\n          inset: calc(50% - var(--b) / 2);\n          background: var(--c);\n          transform: rotate(calc(var(--p) * 3.6deg)) translateY(calc(50% - var(--w) / 2));\n        }\n\n        .animate {\n          animation: p 1s 0.5s both;\n        }\n\n        .no-round:before {\n          background-size: 0 0, auto;\n        }\n\n        .no-round:after {\n          content: none;\n        }\n\n        @keyframes p {\n          from {\n            --p: 0;\n          }\n        }\n      }\n\n      .text-limit {\n        width: 25px;\n        font-size: 0.875rem;\n      }\n\n      .btn-primary {\n        font-weight: 400 !important;\n        font-size: 0.875rem !important;\n        min-height: 2rem;\n        max-width: 100px;\n        min-width: 100px;\n\n        &:hover,\n        &:focus,\n        &:active {\n          background: var(--headerBtnHover) !important;\n          border: none;\n          color: var(--white);\n        }\n      }\n\n      .btn-secondary {\n        font-weight: 500 !important;\n        font-size: 1rem !important;\n        max-width: 56px;\n        min-width: 56px;\n        min-height: 32px;\n      }\n    }\n\n    .gif-input {\n      height: 2rem !important;\n      margin-bottom: 0.25rem !important;\n      width: 80%;\n      margin: 0 auto;\n    }\n  }\n}\n\n.user-profile-modal {\n  .modal-body {\n    padding: 0.625rem !important;\n  }\n\n  .btn-close {\n    background-color: var(--headerBtnHover) !important;\n    border: 2px solid var(--theme-dark) !important;\n    opacity: 1 !important;\n  }\n}\n\n.chat-modal {\n  color: var(--white);\n\n  .btn-close {\n    position: absolute;\n    height: 1rem;\n    width: 1rem;\n    right: 0.313rem;\n    top: 0.313rem;\n    border-radius: 100%;\n    background: var(--chatModalClose);\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media screen and (max-width: 767.98px) {\n      right: 0.625rem;\n      top: 0.625rem;\n    }\n\n    &:hover {\n      opacity: 1;\n    }\n\n    svg {\n      width: 0.625rem;\n      height: 0.625rem;\n    }\n  }\n\n  .modal-dialog {\n    max-width: 436px;\n\n    @media screen and (max-width: 767.98px) {\n      max-width: 100%;\n      padding: 0.625rem;\n      margin: 0;\n    }\n  }\n\n  .chat-modal-header-wrap {\n    background: var(--chatCardBg);\n    border-radius: 0.625rem;\n    margin-bottom: 0.5rem;\n    padding: 1rem;\n\n    h4 {\n      text-transform: capitalize;\n      margin: 0;\n      padding-right: 1rem;\n      font-size: 1.125rem;\n      font-weight: 600;\n    }\n\n    .tip-btn {\n      height: 1.5rem;\n      min-height: 1.5rem;\n      background: var(--tipBtnBg);\n      border: 1px solid var(--authTabActiveBorder);\n      border-radius: 0.313rem;\n      color: var(--white);\n      font-size: 0.75rem;\n      font-weight: 600;\n      line-height: 1.5rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 0 0.5rem 0 0.313rem;\n      margin-right: 0.75rem;\n\n      & img {\n        width: 0.938rem;\n        height: 0.938rem;\n      }\n    }\n\n    .edit-btn {\n      min-height: unset;\n      height: 1.5rem;\n      width: 1.5rem;\n      border: 1px solid var(--headerBtnHover);\n      border-radius: 0.313rem;\n      color: var(--authSocailTextColor);\n      font-size: 0.875rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 0;\n      margin: 0 0.5rem 0 auto;\n\n      i {\n        font-size: 13px;\n      }\n    }\n\n    .chat-modal-header-right {\n      flex: 1;\n\n      .progress {\n        height: 6px;\n      }\n    }\n  }\n\n  .chat-modal-content {\n    background: var(--chatCardBg);\n    border-radius: 0.625rem;\n    margin-top: 0.5rem;\n    padding: 0.625rem;\n\n    .chat-bets {\n      h4 {\n        color: var(--authSocailTextColor);\n        font-size: 0.875rem;\n        font-weight: 500;\n      }\n\n      p {\n        color: var(--white);\n        font-size: 0.875rem;\n        padding-left: 0.313rem;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .progrees-content {\n    p {\n      font-size: 0.875rem;\n      color: var(--authSocailTextColor);\n      font-weight: 500;\n\n      span {\n        color: var(--liveGreen);\n        padding: 0 0.2rem;\n        font-weight: 600;\n      }\n    }\n  }\n\n  .favourites-game-wrap {\n    margin-right: 1rem;\n\n    .favourites-game-img {\n      height: 78px;\n      width: 78px;\n      border-radius: 0.313rem;\n      overflow: hidden;\n      margin-right: 1rem;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: fill;\n      }\n    }\n\n    .favourites-game-right {\n      p {\n        font-size: 0.75rem;\n        color: var(--authTabBtnText);\n        font-weight: 600;\n      }\n\n      h4 {\n        color: var(--white);\n        font-size: 1rem;\n        max-width: 140px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        font-weight: 700;\n      }\n    }\n  }\n\n  .chat-modal-profile-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    // gap: 0.75rem;\n  }\n\n  .chat-modal-profile-img {\n    width: 5rem;\n    min-width: 5rem;\n    height: 5rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n\n    // &::after {\n    //   content: \"\";\n    //   height: 110px;\n    //   width: 1.5px;\n    //   background-color: var(--chatModalBorder);\n    //   position: absolute;\n    //   right: -16px;\n    // }\n\n    img {\n      width: 100%;\n      height: 100%;\n      border-radius: 3.313rem;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  .chat-modal-header-left {\n    width: 4.375rem;\n    padding: 0.25rem;\n    // margin-left: 0.625rem;\n\n    & img {\n      width: 100%;\n      max-width: 62px;\n      height: auto;\n    }\n  }\n\n  .modal-body {\n    padding: 0.625rem;\n    background: var(--theme-dark);\n    border-radius: 1rem;\n    border: 1px; //solid var(--chatModalBorder)\n  }\n}\n\n.account-btn-mid-content {\n  font-weight: 600;\n\n  @media screen and (max-width: 767.98px) {\n    p {\n      font-size: 0.74rem;\n    }\n  }\n}\n\n.btn {\n  &.balance-btn {\n    @media screen and (max-width: 767.98px) {\n      font-size: 0.74rem;\n    }\n\n    &:hover {\n      background: var(--darkGray);\n      cursor: default;\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 0.25rem 0.625rem;\n  }\n}\n\n.chat-modal-wrap {\n  .modal-dialog {\n    position: relative;\n    border-radius: 0.625rem;\n    min-width: 620px;\n  }\n\n  .btn-close {\n    filter: invert(10);\n    opacity: 1;\n    width: 0.625rem;\n    background-size: 0.625rem;\n    right: 0.313rem;\n    top: 0.313rem;\n    position: absolute;\n    z-index: 1;\n    box-shadow: none;\n  }\n}\n\n.upload-modal {\n  .modal-dialog {\n    max-width: 468px !important;\n\n    .btn-close {\n      border-radius: 100%;\n      background: var(--chatModalClose);\n      opacity: 1;\n      top: 1.5rem;\n      right: 1.5rem;\n    }\n\n    .profile-pic-wrapper {\n      .image-upload-box {\n        position: relative;\n\n        svg {\n          width: 45px;\n        }\n\n        .drop-title {\n          margin-bottom: 0;\n          font-weight: 500;\n          font-size: 0.875rem;\n\n          span {\n            color: var(--headingLink);\n            text-decoration: underline;\n\n            &:hover {\n              text-decoration: none;\n              cursor: pointer;\n            }\n          }\n\n          ::-webkit-file-upload-button {\n            cursor: pointer;\n          }\n        }\n\n        .drop-limit {\n          margin-bottom: 0;\n          font-weight: 400;\n          font-size: 0.875rem;\n          color: var(--authSocailTextColor);\n        }\n      }\n\n      input[type=\"file\"] {\n        position: absolute;\n        top: -2px;\n        height: 20px;\n        right: 0;\n        width: 50px;\n        cursor: pointer;\n        opacity: 0;\n      }\n    }\n  }\n\n  .modal-footer {\n    .btn-primary {\n      border: 1px solid var(--headingLink);\n    }\n  }\n}\n\n.tip-modal {\n  .modal-dialog {\n    max-width: 400px;\n    min-width: 400px;\n\n    @media screen and (max-width: 767.98px) {\n      max-width: 100%;\n      min-width: 100%;\n    }\n\n    .modal-content {\n      overflow: hidden;\n\n      h3 {\n        font-size: 1.25rem;\n        font-weight: 700;\n        margin-bottom: 1.5rem;\n      }\n\n      .form-label,\n      .form-check label {\n        font-size: 0.75rem;\n      }\n\n      .modal-footer {\n        background: var(--weekBg);\n        padding: 1.5rem;\n        justify-content: flex-start;\n      }\n    }\n  }\n}\n\n#profile-pic-modal {\n  .modal-footer {\n    background: transparent;\n  }\n}\n\n.cashier-modal {\n  .modal-dialog {\n    min-width: 805px;\n\n    @media screen and (max-width: 1024.98px) {\n      min-width: 100%;\n      margin: 0;\n      padding: 0.625rem;\n      // height: 100%;\n    }\n\n    .modal-body {\n      padding: 2rem;\n\n      @media screen and (max-width: 767.98px) {\n        padding: 0.625rem 1rem;\n      }\n\n      .nav-link {\n        color: var(--authSocailTextColor);\n        opacity: 0.8;\n      }\n\n      .nav-tabs .nav-item .nav-link:hover,\n      .nav-tabs .nav-item .nav-link.active,\n      .nav-pills .nav-item .nav-link:hover,\n      .nav-pills .nav-item .nav-link.active {\n        color: var(--white);\n        border-color: var(--nft-badge);\n      }\n\n      .deposit-step-one {\n        .deposit-card {\n          background: var(--weekBg);\n          padding: 2rem;\n          text-align: center;\n          border-radius: 0.313rem;\n          cursor: pointer;\n          height: 100%;\n\n          .deposit-card-icon {\n            height: 30px;\n            width: 30px;\n            border-radius: 100%;\n            margin: 0 auto 0.625rem;\n\n            img {\n              height: 100%;\n              width: 100%;\n              object-fit: cover;\n            }\n          }\n\n          h4 {\n            color: var(--white);\n            margin: 0;\n            font-size: 1rem;\n          }\n\n          p {\n            color: var(--authSocailTextColor);\n            text-transform: capitalize;\n            margin: 0;\n            font-size: 0.875rem;\n          }\n        }\n      }\n    }\n\n    .cashier-heading {\n      margin-bottom: 1.5rem;\n      display: flex;\n      align-items: center;\n\n      @media screen and (max-width: 767.98px) {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n\n      h3 {\n        display: flex;\n        align-items: center;\n        font-size: 1.375rem;\n        color: var(--white);\n        font-weight: 700;\n      }\n\n      a {\n        color: var(--headingLink);\n        font-size: 0.875rem;\n        padding-left: 0.625rem;\n        font-weight: 700;\n      }\n\n      .currency-icon {\n        height: 30px;\n        width: 30px;\n        border-radius: 100%;\n        overflow: hidden;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-right: 0.625rem;\n\n        img {\n          height: 100%;\n          width: 100%;\n          object-fit: cover;\n        }\n      }\n\n      .left-arrow {\n        padding: 0;\n\n        svg {\n          filter: brightness(10);\n          width: 1rem;\n          height: 1rem;\n          margin-right: 1rem;\n        }\n      }\n    }\n\n    .modal-inner-card {\n      background: var(--socialLinksBg);\n      padding: 1rem;\n      border-radius: 0.625rem;\n      color: var(--authSocailTextColor);\n\n      p {\n        margin-bottom: 16px;\n        line-height: 1.6;\n        color: var(--authSocailTextColor);\n        font-size: 0.865rem;\n        font-weight: 500;\n        font-style: normal;\n        padding-right: 2rem;\n      }\n\n      .qr-code {\n        canvas {\n          border: 5px solid var(--white);\n        }\n\n        @media screen and (max-width: 767.98px) {\n          margin-bottom: 2rem;\n          text-align: center;\n        }\n\n        img {\n          width: 100%;\n        }\n      }\n\n      .change-username {\n        label {\n          text-transform: uppercase;\n          color: var(--white);\n          font-size: 0.875rem;\n\n          @media screen and (max-width: 767.98px) {\n            font-size: 0.75rem;\n          }\n\n          span {\n            color: var(--loss);\n          }\n        }\n\n        .form-group {\n          position: relative;\n\n          .btn-secondary {\n            position: absolute;\n            right: 0.625rem;\n            top: 1.95rem;\n            min-height: 1.875rem;\n            font-size: 0.813rem;\n            display: flex;\n            align-items: center;\n          }\n\n          .form-control {\n            @media screen and (max-width: 767.98px) {\n              padding-right: 10rem;\n            }\n\n            &:focus {\n              border-color: var(--secondaryBtnBorder);\n            }\n          }\n        }\n\n        p {\n          color: var(--white);\n          text-transform: uppercase;\n          font-size: 0.875rem;\n          line-height: 1.75rem;\n          font-weight: 700;\n        }\n\n        .form-text-wrap {\n          margin: 0.313rem 0;\n\n          p {\n            font-size: 0.75rem;\n            font-weight: 500;\n            line-height: 1.063;\n            color: var(--authSocailTextColor);\n            text-transform: capitalize;\n          }\n        }\n\n        .btn-primary {\n          background: var(--socialLinksBg);\n\n          &:hover {\n            background: var(var(--secondaryBtn));\n          }\n        }\n      }\n\n      .currency-converter {\n        .form-group {\n          img {\n            position: absolute;\n            left: 1rem;\n            top: 1rem;\n            height: 20px;\n            width: 20px;\n          }\n\n          input {\n            padding-left: 2.5rem;\n          }\n        }\n\n        span {\n          padding: 0 1rem;\n          color: var(--white);\n        }\n\n        button>span {\n          padding: 0;\n        }\n      }\n\n      .payment-left-card {\n        h4 {\n          line-height: 1.6;\n          font-size: 0.875rem;\n          font-weight: 500;\n          font-style: normal;\n        }\n      }\n\n      .payment-card-right {\n        img {\n          width: 3rem;\n          margin: 0 0.313rem;\n        }\n      }\n    }\n\n    .bitcoin-instruction-list {\n      margin-top: 1.2rem;\n\n      li {\n        font-size: 0.865rem;\n        font-weight: 500;\n      }\n    }\n\n    .modal-btn-wrap {\n      @media screen and (max-width: 767.98px) {\n        margin-top: 1rem;\n      }\n\n      .btn {\n        font-size: 0.75rem;\n        margin-left: 0.625rem;\n        line-height: 1rem;\n        height: 46px;\n\n        @media screen and (max-width: 767.98px) {\n          width: 100%;\n          margin-left: 0;\n          margin-bottom: 1rem;\n        }\n      }\n    }\n\n    .coupon-section {\n      text-align: center;\n\n      img {\n        width: 8rem;\n        height: 8rem;\n        margin: 0 auto;\n      }\n\n      h4 {\n        color: var(--white);\n        font-weight: 700;\n      }\n\n      .form-group {\n        max-width: 220px;\n        margin: 1.5rem auto;\n      }\n\n      p {\n        color: var(--white);\n        font-weight: 500;\n\n        a {\n          color: var(--headingLink);\n          padding-left: 0.2rem;\n          display: inline-block;\n        }\n      }\n\n      .btn {\n        min-width: 140px;\n        margin: 1rem auto;\n      }\n    }\n\n    .nav-pills {\n      @media screen and (max-width: 767.98px) {\n        flex-wrap: nowrap;\n        overflow-x: auto;\n        width: 100%;\n        margin-top: 1.5rem;\n      }\n    }\n\n    .btn-info {\n      @media screen and (max-width: 767.98px) {\n        font-size: 0.75rem;\n      }\n    }\n\n    .modal-content {\n      height: 100%;\n    }\n  }\n\n  .error-msg {\n    margin: 0;\n    position: absolute;\n  }\n}\n\n.cashier-btn {\n  .nav {\n    gap: 0.75rem;\n\n    .nav-item {\n      .nav-link {\n        background-color: var(--authTabBtn);\n        border: 2px solid var(--authTabBtn);\n        border-radius: 0.625rem;\n        color: var(--authTabBtnText);\n        font-size: 0.875rem;\n        font-weight: 600;\n        line-height: 1.75rem;\n        padding: 0.375rem 1.625rem;\n\n        &:hover {\n          background-color: var(--headerBtnHover);\n          border: 2px solid var(--headerBtnHover);\n          color: var(--authTabActiveBorder);\n        }\n\n        &.active,\n        &.active:hover {\n          background-color: var(--authTabBtn);\n          border: 2px solid var(--authTabActiveBorder);\n          color: var(--authTabActiveBorder) !important;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
